import { FormError } from "formvalidation/FormContext"
import { parseValidationResultToError } from "formvalidation/hooks"

type OnKeyDownProps<TValue> = {
  onEsc?: () => void
  onEnter?: () => void
  validation: {
    validate: (newValue: TValue) => Promise<boolean | string>
    setError: (error: FormError) => void
  }
  value: TValue
}
export const saveOrCancel = async <TValue>(e: React.KeyboardEvent, props: OnKeyDownProps<TValue>) => {
  if (e.key === "Escape") {
    props.onEsc?.();
  } else if (e.key === "Enter") {
    if (props.validation == null) {
      props.onEnter?.();
    } else {
      const valid = await props.validation.validate(props.value);
      props.validation.setError(parseValidationResultToError(valid));

      if (valid) {
        props.onEnter?.();
      }
    }
  }
}